import { Injectable } from '@angular/core';
import { IMenu } from '../utils/IMenu';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MainService {
  private menus: IMenu[] = [];

  private menuDashboard: IMenu = { id: 1, nom: 'Dashboard', url: '/accueil' };
  private menuCorrespondance: IMenu = {
    id: 2,
    nom: 'Correspondance',
    url: '/correspondance',
  };
  private menuErreurCorrespondance: IMenu = {
    id: 3,
    nom: 'Erreur de correspondance',
    url: '/erreur-correspondance',
  };
  private menuOsCorrespondance: IMenu = {
    id: 4,
    nom: 'Correspondance OS',
    url: '/os-correspondance',
  };
  private menuIncident: IMenu = { id: 5, nom: 'Incidents', url: '/incident' };
  private menuAffranchi: IMenu = {
    id: 6,
    nom: 'Incidents affranchis',
    url: '/affranchi',
  };
  private menuStats: IMenu = {
    id: 7,
    nom: 'Statistiques',
    url: '/stats',
  };

  constructor(private http: HttpClient) {
    this.menus.push(this.menuDashboard);
    this.menus.push(this.menuCorrespondance);
    this.menus.push(this.menuErreurCorrespondance);
    this.menus.push(this.menuOsCorrespondance);
    this.menus.push(this.menuIncident);
    this.menus.push(this.menuAffranchi);
    this.menus.push(this.menuStats);
  }

  getMenus(): IMenu[] {
    return this.menus;
  }

  createSyncro(){
    return this.http.get<boolean>(`${environment.urlBackend}syncro`);
  }
}
